/* sk-bundle-guard.js — Bundle-Rabatt nur für das echte Bundle (Philipp/Tracking-Agent 31.10.2026).
   Problem: BUNDLE10-…-Codes (Shopify Basic-Code, 10 % auf die Bundle-Produkte, Mindestmenge = Anzahl) gelten auch für
   zusätzliche Zeilen derselben Produkte (z. B. Bundle + extra 2 × 500 ml) → mehr Rabatt als beabsichtigt. Basic-Codes kennen
   keine Höchstmenge je Produkt, Shopify Functions gibt es ohne Plus nicht.
   Lösung: Nach jeder Warenkorb-Änderung (/cart/add|change|update|clear per fetch) und beim Seitenaufruf prüfen:
   Ein BUNDLE10-Code bleibt nur, wenn der Warenkorb GENAU die markierten Bundle-Zeilen enthält
   (Line-Properties _sk_bundle_code = Code, _sk_bundle_n = Anzahl, je Menge 1) und KEINE weitere Zeile derselben Produkte.
   Sonst wird der Code entfernt (/cart/update.js discount=…, andere Codes bleiben) → alle Zeilen voller Preis.
   Restrisiko: wer den Code kennt und im Checkout selbst eintippt, umgeht die Prüfung (Mindestmenge bleibt). */
(function () {
  'use strict';
  if (window.__skBundleGuard) return;
  window.__skBundleGuard = true;
  var origFetch = window.fetch;
  if (!origFetch) return;
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = 0;
  var busy = false;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && init.headers['X-SK-Guard'];
    var p = origFetch.apply(this, arguments);
    if (!own && RX.test(url)) p.then(schedule, function () {});
    return p;
  };
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 300); }
  function check() {
    if (busy) { schedule(); return; }
    busy = true;
    origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var bad = codes.filter(function (code) {
          if (!/^BUNDLE10-/i.test(code)) return false;
          var up = code.toUpperCase();
          var tagged = cart.items.filter(function (i) { return i.properties && String(i.properties._sk_bundle_code || '').toUpperCase() === up; });
          if (!tagged.length) return true;
          var n = Number(tagged[0].properties._sk_bundle_n) || 0;
          var pids = tagged.map(function (i) { return i.product_id; });
          var exact = tagged.length === n && tagged.every(function (i) { return i.quantity === 1; });
          var noExtra = cart.items.every(function (i) { return tagged.indexOf(i) >= 0 || pids.indexOf(i.product_id) < 0; });
          return !(exact && noExtra);
        });
        /* Bestellung #136545 (Philipp 01.11.2026): Wurde ein Bundle im Warenkorb gekürzt (Zeile gelöscht / Menge ≠ 1), blieben
           _sk_bundle*-Properties an den Restzeilen hängen → Bestellung trug halbe Bundle-Marker (Statistik!). Unvollständige
           Bundle-Gruppen werden hier per /cart/change.js (id = Zeilen-Key, properties überschreiben die Zeile) bereinigt. */
        var groups = {};
        cart.items.forEach(function (i) {
          var pr = i.properties || {};
          if (!pr._sk_bundle || !pr._sk_bundle_n) return;
          var gk = String(pr._sk_bundle) + '|' + String(pr._sk_bundle_code || '');
          (groups[gk] = groups[gk] || []).push(i);
        });
        var broken = [];
        Object.keys(groups).forEach(function (gk) {
          var g = groups[gk];
          var n = Number(g[0].properties._sk_bundle_n) || 0;
          if (g.length < n || g.some(function (i) { return i.quantity !== 1; })) broken = broken.concat(g);
        });
        if (!bad.length && !broken.length) return null;
        var keep = codes.filter(function (c) { return bad.indexOf(c) < 0; });
        var post = function (url, body) {
          return origFetch(url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-SK-Guard': '1' },
            body: JSON.stringify(body)
          });
        };
        var step = bad.length ? post('/cart/update.js', { discount: keep.join(',') }) : Promise.resolve();
        broken.forEach(function (it) {
          step = step.then(function () { /* Leere Property-Werte würden in cart.js stehen bleiben → Zeile entfernen und ohne _sk_bundle*-Properties neu hinzufügen
             (übrige Properties bleiben erhalten) */
            var pr = {}; Object.keys(it.properties || {}).forEach(function (k) { if (!/^_sk_bundle/.test(k)) pr[k] = it.properties[k]; });
            return post('/cart/change.js', { id: it.key, quantity: 0 }).then(function () {
              return post('/cart/add.js', { items: [{ id: it.variant_id, quantity: it.quantity, properties: pr }] });
            });
          });
        });
        return step.then(function () {
          document.dispatchEvent(new CustomEvent('sk:bundle-discount-removed', { detail: { codes: bad, cleaned: broken.length } }));
          if (window.skDrawer && typeof window.skDrawer.refresh === 'function') window.skDrawer.refresh();
          if (/\/cart\/?$/.test(location.pathname)) location.reload();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  /* Beim Seitenaufruf nur prüfen, wenn der Warenkorb nicht leer ist (window.skCart aus snippets/sk-cart-assets) */
  if (!window.skCart || window.skCart.itemCount > 0) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  }
})();
